module.exports = __webpack_public_path__ + "img/upgrade.edb6713e.png";